import React from 'react';
import trms from "../trms.png";
import tms from "../tms.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from '@fortawesome/free-solid-svg-icons';
import {PopupboxManager, PopupboxContainer} from "react-popupbox" ;
import "react-popupbox/dist/react-popupbox.css"


const Projects = () => {

    // TRMS
    const openPopupboxtrms = () => {
        const content = (
        <>
        <img className="project-img-popup1" src={trms} alt="TRMS Project photo "/>
        <p>Web application to manage the details of the teachers in an organized format.<br/>
        Web application is now being used by our department in order to manage details of the teachers of my college.</p>
        <b>Github: </b><a className="hyper-link" onClick={ () => window.open("https://github.com/uvyuva/Teacher-Record-Management-System") } >
            https://github.com/uvyuva/Teacher-Record-Management-System</a>
        </>
        )
        PopupboxManager.open({ content })
    } 
    const popupboxConfigtrms = {
            titleBar: {
                enable: true,
                text: "Teacher Record Management System."
            },
            fadeIn: true,
            fadeInSpeed: 500
    }
     // TMS
     const openPopupboxtms = () => {
        const content = (
        <>
        <img className="project-img-popup2" src={tms} alt="TMS Project photo "/>
        <p>This is an web application for Alvas Organization in order to maintain the details of vehicals<br/>
            The project is under development.This application is an ERP for the organiztion</p>
        </>
        )
        PopupboxManager.open({ content })
    } 
    const popupboxConfigtms = {
            titleBar: {
                enable: true,
                text: "Teacher Record Managemenet System."
            },
            fadeIn: true,
            fadeInSpeed: 500
    }


    return (
        <div id="projects" className="project-wrapper">
            <div className="container">
                <h1 className="text-uppercase text-color-dark text-center py-5">Projects</h1>
                <div className="image-box-wrapper row justify-conent-center">
                    <div className="imga">
                    <div className="project-img-box1" onClick={openPopupboxtrms}>
                        <img className="project-img1" src={trms}  />
                        <div className="overflow1"></div>
                        <FontAwesomeIcon className="project-icon1" icon={faSearchPlus} />
                    </div>
                    {/*  */}
                    <div className="project-img-box2" onClick={openPopupboxtms}>
                        <img className="project-img2" src={tms}  />
                        <div className="overflow2"></div>
                        <FontAwesomeIcon className="project-icon" icon={faSearchPlus} />
                    </div>
                    </div>
                </div>
            </div>
            <PopupboxContainer {...popupboxConfigtrms} />
            <PopupboxContainer {...popupboxConfigtms} />
        </div>
    )
}

export default Projects
